const initialState = {
    responseZonesList: [],
    responseZone: []
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };

    switch (action.type) {
        case "ZONES_RESPONSE_LIST":
            
            if (action.value.detail !== undefined)
                newState.responseZonesList = []
            else
                newState.responseZonesList = action.value;
            
            newState.responseZone = []
            break;
        case "ZONE_RESPONSE":
      
            newState.responseZone = action.value;
      
            break;
            
        default: 
            return newState;
    }

    return newState;
};

export default reducer;